type Props = {
  trackingId: string;
  extraQs: string;
};

export function HorizonGoogleTagManagerNoScript({
  trackingId,
  extraQs,
}: Props) {
  return (
    <noscript>
      {/* oxlint-disable-next-line jsx_a11y/iframe-has-title, react/iframe-missing-sandbox */}
      <iframe
        src={`https://www.googletagmanager.com/ns.html?id=${trackingId}${extraQs}`}
        height="0"
        width="0"
        style={{ display: 'none', visibility: 'hidden' }}
      ></iframe>
    </noscript>
  );
}
